<template>
  <svg
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="8"
      y="20"
      width="14"
      height="3"
      rx="1.5"
      fill="currentColor"
    />
    <rect
      x="6"
      y="14"
      width="18"
      height="3"
      rx="1.5"
      fill="currentColor"
    />
    <rect
      x="3"
      y="8"
      width="24"
      height="3"
      rx="1.5"
      fill="currentColor"
    />
  </svg>
</template>
